import { Dialog, DialogContent, DialogTitle, Stack, Typography, List, ListItem, ListItemText, Button, Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import StripePaymentComponent from "src/components/stripe/stripe-payment.component";
import { useEffect, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import { paymentModuleUrl } from 'src/services/urlService';

const PaymentDialogComponent = ({ clientSecret, amount,planName, handleClose, currencySymbol }) => {
    const { t: translate } = useTranslation();
    const [methods, setMethods] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        const fetchMethods = async () => {
            const orgId = CommonHelper.GetBrandInfoFromLocalStorage('org_id');
            if (!orgId) return;
            const res = await fetch(`${paymentModuleUrl.paymentMethods}${orgId}`);
            if (!res.ok) return;
            const data = await res.json();
            // data should be list of payment methods in data.data
                const items = data && data.data && data.data.length ? data.data : (data && data.data ? data.data : []);
                setMethods(items);
                // pick default if present
                const defaultPM = data && data.default_payment_method ? data.default_payment_method : null;
                if (defaultPM) setSelected(defaultPM);
        };
        fetchMethods();
    }, []);

    const setDefault = async (pmId) => {
        // prefer org id from initial-load
        let orgId = CommonHelper.GetBrandInfoFromLocalStorage('org_id');
        if (!orgId) {
            const user = CommonHelper.GetLoggedInUserDetailsFromLocalStorage();
            orgId = user && user.org_id ? user.org_id : null;
        }
        if (!orgId) return;
        const res = await fetch(paymentModuleUrl.savePaymentMethod, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ org_id: orgId, payment_method: pmId, enable_autopay: true }),
        });
        if (res.ok) {
            setSelected(pmId);
        }
    };

    return (
        <Dialog onClose={() => { handleClose(false) }} open>
            <DialogTitle>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight="bold">{translate("billing.subscription_info.payment")}</Typography>
                </Stack> </DialogTitle>
            <DialogContent dividers>
                {methods && methods.length > 0 && (
                    <List>
                        {methods.map((m) => (
                            <ListItem key={m.id} secondaryAction={<Button variant="outlined" onClick={() => setDefault(m.id)}>{translate('billing.subscription_info.set_default')}</Button>}>
                                <Radio checked={selected === m.id} onChange={() => setDefault(m.id)} />
                                <ListItemText primary={m.card.brand + ' **** ' + m.card.last4} secondary={m.card.exp_month + '/' + m.card.exp_year} />
                            </ListItem>
                        ))}
                    </List>
                )}
                <StripePaymentComponent clientSecret={clientSecret} planName={planName} currencySymbol={currencySymbol} amount={amount} />
            </DialogContent>
        </Dialog>
    );
}
export default PaymentDialogComponent;